module.exports = __webpack_public_path__ + "static/media/cristales.571863ce.svg";